export const dateTimeZero = (value) => {
  const params = value.split("-");
  params[1] = Number.parseInt(params[1]) - 1;
  const d = new Date(...params);

  return d;
};
